import { Avatar, Stack, Typography } from '@mui/material';
import { GreenTriangle } from 'Images';

interface ILabel {
  text: string;
}

export const Label = ({ text }: ILabel) => {
  return (
    <Stack
      sx={{
        position: 'absolute',
        top: '5px',
        left: '-14px',
        bgcolor: '#007A52',
        width: 'fit-content',
        p: '2px 10px 4px 10px',
        borderRadius: '16px 0 8px 0',
      }}
    >
      <Typography
        variant='body5'
        sx={{
          color: '#fff',
        }}
      >
        {text}
      </Typography>
      <Avatar
        alt=''
        src={GreenTriangle}
        sx={{
          width: '15px',
          height: '13px',
          position: 'absolute',
          left: 0,
          bottom: '-13px',
        }}
      />
    </Stack>
  );
};
